module.exports = __webpack_public_path__ + "assets/upload.84d5b598.svg";